import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import './TermsModal.css';
import { useTranslations } from '../../../../shared/src/hooks/use-translations.hook';
import { TermsOkSection } from './TermsOkSection';

export const TermsModal = ({ fullTnC, handleToggleModal, isModalOpen }) => {
    const { isMobile } = useSelector(state => state.app);
    const { t } = useTranslations();

    useEffect(() => {
        if (isMobile) {
            document.body.classList.add('homepage--modal-opened');
        }

        return () => document.body.classList.remove('homepage--modal-opened');
    }, []);

    return (
        <div
            className={isModalOpen ? 'terms-modal-container active' : 'terms-modal-container'}
            onClick={handleToggleModal}
        >
            <div
                className={isModalOpen ? 'terms-modal-content active' : 'terms-modal-content'}
                onClick={(e) => e.stopPropagation()}
            >
                <div className="terms-modal-wrapper">
                    <div className="terms-modal-title">
                        {t('termsAndConditionsPROMOTION')}

                        <div onClick={handleToggleModal} className="terms-modal-close-button"></div>
                    </div>

                    <div className="terms-modal-text">
                        <div className="terms-modal-text__content" dangerouslySetInnerHTML={{ __html: fullTnC }}></div>

                        {isMobile && <TermsOkSection onClick={handleToggleModal} buttonText={t('ok')} />}
                    </div>
                </div>
                {!isMobile && <TermsOkSection onClick={handleToggleModal} buttonText={t('ok')} />}
            </div>
        </div>);
};
